/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Warehouse_Sales_DefectsInputs */

const vi_nav_warehouse_sales_defects = /** @type {(inputs: Nav_Warehouse_Sales_DefectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hàng lỗi`)
};

/**

* @param {Nav_Warehouse_Sales_DefectsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_warehouse_sales_defects = /** @type {((inputs?: Nav_Warehouse_Sales_DefectsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Warehouse_Sales_DefectsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_warehouse_sales_defects(inputs)
});